export default {
  textColor: 'brandOne20',
  buttonStyle: 'secondaryInverseOutline',
  teamReference: 'Agria UK',
} as const;
